import { urlDefaultAux, controlador, empresa } from "../../../constants/urls";

// Catálogos para Motos
export const urlListarProvinciasMotos = `${urlDefaultAux}${controlador}provincias/listarprovincias-aig&ramo=vehiculos${empresa}`;
export const urlListarSucursalesMotos = `${urlDefaultAux}${controlador}sucursales/listar-sucursalesaig${empresa}`;
export const urlListarMarcasMotos = `${urlDefaultAux}${controlador}marcas/listar-marcas-aig${empresa}`;
export const urlListarModelosMotos = `${urlDefaultAux}${controlador}modelos/listar-modelos-aig${empresa}&filtro=&producto=&motos=true&marca=`;
export const urlListarAccesoriosMotos = `${urlDefaultAux}${controlador}accesorios/listar-accesorios-aig${empresa}`;
export const urlListarColoresMotos = `${urlDefaultAux}${controlador}site/listar-colores-aig${empresa}`;
export const urlConsultarCedulaMotos = `${urlDefaultAux}${controlador}site/consultar-cedula-aig${empresa}&plataforma=WEB&identificacion=`;

// Endpoints del Cotizador de Motos (Middleware)
export const urlGuardarCotizacionMotoPaso1 = `${urlDefaultAux}${controlador}motos/motos/guardar-cotizacion-paso1`;
export const urlObtenerCotizacionMoto = `${urlDefaultAux}${controlador}motos/motos/obtener-cotizacion`;
export const urlObtenerPdfCotizacionMoto = `${urlDefaultAux}${controlador}motos/motos/cotizacion-pdf&idCarrito=`;
export const urlEnviarPdfCotizacionMoto = `${urlDefaultAux}${controlador}motos/motos/enviar-cotizacion-pdf&idCarrito=`;

